export default "__VITE_ASSET__BYSQ0zan__"